// extracted by mini-css-extract-plugin
module.exports = {"container":"v_image_text_upload_container_container__CdUdy","textarea":"v_image_text_upload_container_textarea__BcAfe"};